import { ItiLink as Link } from 'components';
import dayjs from 'dayjs';
import { default as utc } from 'dayjs/plugin/utc';
import { Invoice } from 'types';

dayjs.extend(utc);

const DollarFormatter = new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD'
});
const gridTemplateColumns = '.75fr 1fr 1.25fr 1.6fr .6fr 1fr .6fr 1fr 1fr 1fr .6fr 1fr';

export const InvoiceDetailsCredits = (props: { invoice: Invoice }) => {
  const getUnitNumberById = (id: number) => {
    return props.invoice.items.find(item => item.unitId === id)?.unitNumber || id;
  };
  return (
    <div className="card-primary raised">
      <div className="card-header">
        <h4 className="">UNIT CREDITS</h4>
      </div>
      <ul className="list-group">
        {/* Header Row */}
        <li className="list-group-item list-group-header grid-12" style={{ gridTemplateColumns }}>
          <p>Unit ID</p>
          <p>Credit</p>
        </li>
        {Object.keys(props.invoice.unitCredits).map(unitId => (
          <li key={unitId} className="list-group-item grid-10 text-base" style={{ gridTemplateColumns }}>
            <p>
              <Link to={`/units/${unitId}`}>{getUnitNumberById(+unitId)}</Link>
            </p>
            <p>{DollarFormatter.format(props.invoice.unitCredits[unitId])}</p>
          </li>
        ))}
      </ul>
    </div>
  );
};
